import React, { FC } from 'react'

import { Link } from 'react-router-dom'

import SidebarNavTab from '@app/pages/Dashboard/SideBar/components/SidebarNavTab/SidebarNavTab'

interface SidebarNavLinkProps {
	readonly to: string
	readonly label: string
	readonly startIconSlot?: React.ReactNode
	readonly checked?: boolean
	readonly sx?: object
	readonly onClick?: React.MouseEventHandler<HTMLAnchorElement>
}

const SidebarNavLink: FC<SidebarNavLinkProps> = ({
	to,
	label,
	startIconSlot,
	checked,
	sx,
	onClick,
}: SidebarNavLinkProps) => {
	return (
		<SidebarNavTab
			component={Link}
			to={to}
			checked={checked}
			onClick={onClick}
			sx={sx}
		>
			{startIconSlot}
			{label}
		</SidebarNavTab>
	)
}

export default SidebarNavLink
